export default __webpack_public_path__ + "static/media/img-step1.c6f8cadb.png";